import React, { memo } from 'react';
import { scrollToPurchase } from '../utils/checkout';
export function WhatsIncluded() {
  const books = [{
    number: '1',
    title: 'Getting Started',
    desc: 'How to prepare your dog, your location, and your light before you even tap the screen.'
  }, {
    number: '2',
    title: 'Phone Camera Basics',
    desc: 'How to use your phone more effectively for sharper, clearer, better-looking dog photos.'
  }, {
    number: '3',
    title: 'Poses and Angles',
    desc: 'Simple ways to make your dog look more expressive, flattering, and photogenic.'
  }, {
    number: '4',
    title: 'Personality and Emotion',
    desc: 'How to capture the little moments that actually feel like your dog.'
  }, {
    number: '5',
    title: 'Movement and Action',
    desc: 'Take better running, jumping, playful, and dynamic dog photos with your phone.'
  }, {
    number: '6',
    title: 'Beautiful Final Results',
    desc: "Create more stylish, frame-worthy dog photos you'll want to save, share, and print."
  }];
  return <section className="bg-warm-deep py-16 md:py-24 px-4" data-id="element-399">
      <div className="max-w-3xl mx-auto" data-id="element-400">
        {/* Skills heading */}
        <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl font-bold text-center text-warm-hero mb-4 leading-tight" data-id="element-401">
          📘 What exactly is included in The{' '}
          <span className="italic text-soft-gold" data-id="element-402">Pawfect</span> Shot MegaPack?
        </h2>

        <h3 className="font-serif text-2xl md:text-3xl font-bold text-center text-warm-hero mb-10" data-id="element-403">
          6 complete books
        </h3>

        {/* Books grid */}
        <div className="space-y-4 mb-12" data-id="element-404">
          {books.map(book => <div key={book.number} className="bg-white p-6 md:p-7 rounded-xl shadow-sm border border-soft-gold/15 flex items-start gap-4" data-id="element-405">
              <div className="flex-shrink-0 w-10 h-10 rounded-full bg-gradient-to-br from-soft-gold to-dark-gold text-white font-sans font-bold text-sm flex items-center justify-center" data-id="element-406">
                {book.number}
              </div>
              <div data-id="element-407">
                <h4 className="font-sans font-bold text-lg text-warm-hero mb-1" data-id="element-408">
                  Book {book.number} — {book.title}
                </h4>
                <p className="font-sans text-gray-600 leading-relaxed" data-id="element-409">
                  {book.desc}
                </p>
              </div>
            </div>)}
        </div>

        <p className="font-sans text-lg md:text-xl text-center text-gray-800 max-w-2xl mx-auto leading-relaxed mb-10 font-medium" data-id="element-410">
          Everything is organized to help you improve faster, capture better
          memories, and stop relying on random luck.
        </p>

        {/* CTA */}
        <div className="text-center" data-id="element-411">
          <button onClick={scrollToPurchase} className="w-full md:w-auto bg-green-600 hover:bg-green-700 text-white font-sans font-bold text-lg md:text-xl py-4 px-10 rounded-full shadow-cta transition-all duration-300 transform hover:-translate-y-1 uppercase text-center" data-id="element-412">
            👉 ACCESS THE MEGAPACK NOW
          </button>
        </div>
      </div>
    </section>;
}